import { DataBean } from "../DataBean";

export class ProductionOrder extends DataBean {
  public async getProductionOrderCatalog(idAccount: number, idProduct: number, code: number, year: number, month: number, fromDate: any, uptoDate: any, idProject: number, idManufacturingStardard: number, idAttentionOffice: number, idStore: number, state: number, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getProductionOrderCatalog_Number_Number_Number_Number_Number_java.util.Date_java.util.Date_Number_Number_Number_Number_Number_Number_Number",
      [idAccount, idProduct, code, year, month, fromDate, uptoDate, idProject, idManufacturingStardard, idAttentionOffice, idStore, state, page, recordsPerPage,]
    );
  }
  public async getProductionOrderCatalogInProcess(idAccount: number, year: number, month: number, fromDate: any, uptoDate: any, idProject: number, idManufacturingStardard: number, idAttentionOffice: number, idStore: number, state: number, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getProductionOrderCatalogInProcess_Number_Number_Number_java.util.Date_java.util.Date_Number_Number_Number_Number_Number_Number_Number",
      [idAccount, year, month, fromDate, uptoDate, idProject, idManufacturingStardard, idAttentionOffice, idStore, state, page, recordsPerPage,]
    );
  }

  public async deleteProductionOrder(idProductionOrder: any, productionOrderDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteProductionOrder_Number_java.util.Date",
      [idProductionOrder, productionOrderDate]
    );
  }

  public async postProductionOrderToProductionProcess(idProductionOrder: any, productionOrderDate: any, idEmployee: any, observations: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_postProductionOrderToProductionProcess_Number_java.util.Date_Number_String",
      [idProductionOrder, productionOrderDate, idEmployee, observations]
    );
  }

  public async rejectProductionOrderToProductionProcess(idProductionOrder: any, productionOrderDate: any, idEmployee: any, observations: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_rejectProductionOrderToProductionProcess_Number_java.util.Date_Number_String",
      [idProductionOrder, productionOrderDate, idEmployee, observations]
    );
  }

  public async postProductionOrderAsFinished(idProductionOrder: any, productionOrderDate: any, idEmployee: any, observations: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_postProductionOrderAsFinished_Number_java.util.Date_Number_String",
      [idProductionOrder, productionOrderDate, idEmployee, observations]
    );
  }

  public async getProductionOrderReport(idProductionOrder: any, productionOrderDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getProductionOrderReport_Number_java.util.Date",
      [idProductionOrder, productionOrderDate]
    );
  }

  public async getProductionOrderCatalogByProductionRejected(idAccount: number, year: number, month: number, fromDate: any, uptoDate: any, idProject: number, idManufacturingStardard: number, idAttentionOffice: number, idStore: number, state: number, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getProductionOrderCatalogByProductionRejected_Number_Number_Number_java.util.Date_java.util.Date_Number_Number_Number_Number_Number_Number_Number",
      [idAccount, year, month, fromDate, uptoDate, idProject, idManufacturingStardard, idAttentionOffice, idStore, state, page, recordsPerPage,]
    );
  }

  public async getProductionOrderCatalogForInvoice(idAccount: number, year: number, month: number, fromDate: any, uptoDate: any, idProject: number, idManufacturingStardard: number, idAttentionOffice: number, idStore: number, state: number, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getProductionOrderCatalogForInvoice_Number_Number_Number_java.util.Date_java.util.Date_Number_Number_Number_Number_Number_Number_Number",
      [idAccount, year, month, fromDate, uptoDate, idProject, idManufacturingStardard, idAttentionOffice, idStore, state, page, recordsPerPage,]
    );
  }

  public async getProductionOrderCatalogForRawMaterial(idAccount: number, year: number, month: number, idProject: number, idManufacturingStardard: number, idAttentionOffice: number, idStore: number, page: number, recordsPerPage: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getProductionOrderCatalogForRawMaterial_Number_Number_Number_Number_Number_Number_Number_Number_Number",
      [idAccount, year, month, idProject, idManufacturingStardard, idAttentionOffice, idStore, page, recordsPerPage]
    );
  }

  public async parseDates(yearFrom: number, yearUpto: number, monthFrom: number, monthUpto: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.Movement_parseDates_Number_Number_Number_Number",
      [yearFrom, yearUpto, monthFrom, monthUpto]
    );
  }

  public async getProductionOrderStateConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getProductionOrderStateConstants_Number",
      [arg]
    );
  }

  public async getProductionOrderRequestConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getProductionOrderRequestConstants_Number",
      [arg]
    );
  }

  public async importProductionOrders(filename: string, directory: string, dataStore: string): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_importProductionOrders_String_String_String",
      [filename, directory, dataStore]
    );
  }

  public async postProductionOrderAsCanceled(idProductionOrder: number, productionOrderDate: any, idEmployee: number, observations: string): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_postProductionOrderAsCanceled_Number_java.util.Date_Number_String",
      [idProductionOrder, productionOrderDate, idEmployee, observations]
    );
  }

  public async postProductionOrderAsNullify(idProductionOrder: number, productionOrderDate: any, idEmployee: number, observations: string): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_postProductionOrderAsNullify_Number_java.util.Date_Number_String",
      [idProductionOrder, productionOrderDate, idEmployee, observations]
    );
  }

  public async setRealDatesToProductionOrder(idProductionOrder: number, productionOrderDate: any, fromRealDate: any, uptoRealDate:any, idEmployee: number, observations: string): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_setRealDatesToProductionOrder_Number_java.util.Date_java.util.Date_java.util.Date_Number_String",
      [idProductionOrder, productionOrderDate, fromRealDate, uptoRealDate, idEmployee, observations]
    );
  }

  public async updateProductionOrder(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.productionorders.ProductionOrder_updateProductionOrder_com.quickdataerp.bean.productionorders.ProductionOrder",
      [
        {
          DataBeanProperties: bean,
          DataBeanName:
            "com.quickdataerp.bean.productionorders.ProductionOrder",
        },
      ]
    );
  }
}
